import type { GetQuickSearchResultsV2QueryVariables } from '../../gql/generated/GetQuickSearchResultsV2';
import type { ListMode } from '../../hooks/useQuickSearchListMode';
import type {
  QuickSearchMachineOutput,
  QuickSearchTabbedOutput,
} from '../types';
import { useQuickSearchMachineMulti } from './useQuickSearchMachineMulti';
import { useQuickSearchMachineSingle } from './useQuickSearchMachineSingle';
import { useQuickSearchMachineTabbed } from './useQuickSearchMachineTabbed';

type UseQuickSearchMachineProps = {
  requestVariables: GetQuickSearchResultsV2QueryVariables;
  listMode: ListMode;
  skip: boolean;
  isSearchQueryStale: boolean;
  isInitial: boolean;
};

export const useQuickSearchMachine = ({
  requestVariables,
  listMode,
  skip,
  isSearchQueryStale,
  isInitial,
}: UseQuickSearchMachineProps):
  | QuickSearchMachineOutput
  | QuickSearchTabbedOutput => {
  const singleResult = useQuickSearchMachineSingle({
    requestVariables,
    skip: skip || listMode !== 'SINGLE',
    isSearchQueryStale,
    isInitial,
  });

  const multiResult = useQuickSearchMachineMulti({
    requestVariables,
    skip: skip || listMode !== 'MULTI',
    isSearchQueryStale,
    isInitial,
  });

  const tabbedResult = useQuickSearchMachineTabbed({
    requestVariables,
    skip: skip || listMode !== 'MULTI_TABBED',
    isSearchQueryStale,
    isInitial,
  });

  if (listMode === 'MULTI_TABBED') return tabbedResult;
  if (listMode === 'MULTI') return multiResult;
  return singleResult;
};
